import s from "./StatusBadge.module.css";

/** Map a backend status string to its badge class. Unknown values fall
 *  back to the muted "inactive" treatment so future statuses don't render
 *  naked. The set covers the Student lifecycle (PENDING → ENROLLED →
 *  GRADUATED, plus INACTIVE as a soft-delete state). */
function statusBadgeClass(status) {
  switch ((status || "").toUpperCase()) {
    case "ENROLLED":  return s.statusEnrolled;
    case "PENDING":   return s.statusPending;
    case "GRADUATED": return s.statusGraduated;
    case "INACTIVE":  return s.statusInactive;
    default:          return s.statusInactive;
  }
}

export default function StatusBadge({ status, fallback = "PENDING" }) {
  const label = status || fallback;
  return <span className={`${s.statusBadge} ${statusBadgeClass(label)}`}>{label}</span>;
}
